import typeToReducer from 'type-to-reducer';
import {
  CHANGE_DATE_BY_TYPE,
  CHANGE_ACTIVE_TAB,
  FETCH_BONUS_LIST,
  FETCH_CREDIT_BONUS_LIST,
  SET_CURRENT_PAGE,
  FETCH_REGISTRATION_OFFERS,
} from 'accountBonusActions.js';

let initialState = {
  isPending: true,
  error: null,
  startDate: new Date(),
  endDate: new Date(),
  activeTab: 'active',
  bonus: {
    active: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
    history: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
    queue: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
  },
  limit: 5,
  registrationOffers: [],
};

export default typeToReducer(
  {
    [CHANGE_DATE_BY_TYPE]: (state, { payload: { dateType, date } }) => {
      return {
        ...state,
        bonus: {
          active: {
            ...state.bonus.active,
            currentPage: 0,
          },
          queue: {
            ...state.bonus.queue,
            currentPage: 0,
          },
          history: {
            ...state.bonus.history,
            currentPage: 0,
          },
        },
        [dateType]: date,
      };
    },
    [CHANGE_ACTIVE_TAB]: (state, { payload: { activeTab } }) => {
      return {
        ...state,
        bonus: {
          active: {
            ...state.bonus.active,
            currentPage: 0,
          },
          queue: {
            ...state.bonus.queue,
            currentPage: 0,
          },
          history: {
            ...state.bonus.history,
            currentPage: 0,
          },
        },
        activeTab,
      };
    },
    [SET_CURRENT_PAGE]: (state, { payload: { currentPage, activeTab } }) => {
      return {
        ...state,
        bonus: {
          ...state.bonus,
          [activeTab ?? state.activeTab]: {
            ...state.bonus[activeTab ?? state.activeTab],
            currentPage,
          },
        },
      };
    },
    [FETCH_BONUS_LIST]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (
        state,
        { payload: { data, activeTab, isNextPageAvailable, keepPendingStatus } }
      ) => {
        return {
          ...state,
          bonus: {
            ...state.bonus,
            [activeTab ?? state.activeTab]: {
              ...state.bonus[activeTab ?? state.activeTab],
              data,
              isNextPageAvailable,
            },
          },
          ...(!keepPendingStatus && { isPending: false }),
        };
      },
      FULFILLED: (state) => {
        return { ...state, isPending: false };
      },
    },
    [FETCH_CREDIT_BONUS_LIST]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (
        state,
        { payload: { data, activeTab, isNextPageAvailable, keepPendingStatus } }
      ) => {
        return {
          ...state,
          bonus: {
            ...state.bonus,
            [activeTab ?? state.activeTab]: {
              ...state.bonus[activeTab ?? state.activeTab],
              data,
              isNextPageAvailable,
            },
          },
          ...(!keepPendingStatus && { isPending: false }),
        };
      },
      FULFILLED: (state) => {
        return { ...state, isPending: false };
      },
    },
    [FETCH_REGISTRATION_OFFERS]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data } }) => {
        return { ...state, isPending: false, registrationOffers: data };
      },
    },
  },
  initialState
);
